/**
 * Visit and demo counts without cookies (owner, 2026-09-30; backend/services/funnel.js): a number per
 * day, step, source and device. Nothing about the person is sent or kept, so it runs for everybody,
 * consent or not. The source is the site's utm_source, which the site passes on in the link.
 */
import { API_BASE } from '@/config';

export function countStep(step: 'form_view' | 'form_typed' | 'link_page') {
  try {
    const q = new URLSearchParams(window.location.search);
    const body = JSON.stringify({ step, utm: q.get('utm_source') ?? '', ref: '' });
    navigator.sendBeacon?.(`${API_BASE}/count`, body);
  } catch {
    // a count is never worth an error on the page
  }
}

/** The app pages the server counts (backend/services/funnel.js APP_PAGES); anything else is dropped there. */
export type AppPage =
  | 'hjem'
  | 'oversikt'
  | 'dagen'
  | 'vaktplan'
  | 'vaktplan-gammel'
  | 'timeliste'
  | 'arbeidstid'
  | 'lonn'
  | 'omsetning'
  | 'fravaer'
  | 'ansatte'
  | 'prosjekter'
  | 'innstillinger'
  | 'varsler'
  | 'innboks'
  | 'lagvakt'
  | 'min'
  | 'oppsett'
  | 'hugin'
  // the welcome overview opened, and a row pressed in it (#130); never a path, sent by shell/Welcome.tsx
  | 'welcome'
  | `welcome-${WelcomeKey}`;
/** The welcome's jobs (#130), as the server counts them (backend APP_PAGES). */
export type WelcomeKey =
  | 'koble'
  | 'plan'
  | 'stempling'
  | 'kost'
  | 'ledig'
  | 'godkjenn'
  | 'app'
  | 'registrer'
  | 'kunder'
  | 'rapport'
  | 'send'
  | 'hugin';

/** The app page a path belongs to, or null for a path the server does not count (/leads, /konto/…). */
export function appPageOf(pathname: string): AppPage | null {
  const first = pathname.split('/').filter(Boolean)[0] ?? '';
  if (first === 'vaktplan') return pathname.startsWith('/vaktplan/gammel') ? 'vaktplan-gammel' : 'vaktplan';
  const known: AppPage[] = [
    'hjem',
    'oversikt',
    'dagen',
    'timeliste',
    'arbeidstid',
    'lonn',
    'omsetning',
    'fravaer',
    'ansatte',
    'prosjekter',
    'innstillinger',
    'varsler',
    'innboks',
    'lagvakt',
    'min',
    'oppsett',
  ];
  return (known as string[]).includes(first) ? (first as AppPage) : null;
}

/**
 * An app page opened (owner 2026-10-13, "how do people react to the new version"): one beacon per page
 * per visit, with the company kind; no person, no company id, consent or not. backend APP_PAGES.
 */
export function countAppPage(page: AppPage, kind: 'demo' | 'bedrift') {
  try {
    navigator.sendBeacon?.(`${API_BASE}/count`, JSON.stringify({ step: `app:${page}`, kind }));
  } catch {
    // a count is never worth an error on the page
  }
}
